import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "column items-center" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SignUpBackground = _resolveComponent("SignUpBackground")!
  const _component_center = _resolveComponent("center")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_page = _resolveComponent("q-page")!
  const _component_q_page_container = _resolveComponent("q-page-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SignUpBackground),
    _createVNode(_component_q_page_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_q_page, { class: "q-layout-container column justify-center items-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_form, {
              onSubmit: _ctx.submit,
              class: "sign-form column"
            }, {
              default: _withCtx(() => [
                _hoisted_1,
                _createElementVNode("h5", null, [
                  _createVNode(_component_center, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('reset_password')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_q_input, {
                  outlined: "",
                  label: _ctx.$t('new_password'),
                  filled: "",
                  onFocus: _ctx.resetErrors,
                  "label-color": "white",
                  error: _ctx.passwordResetError,
                  modelValue: _ctx.newPassword,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newPassword) = $event)),
                  type: "password"
                }, null, 8, ["label", "onFocus", "error", "modelValue"]),
                _createVNode(_component_q_btn, {
                  class: "col",
                  label: "Сменить пароль",
                  type: "submit",
                  loading: _ctx.loading,
                  color: "white",
                  "text-color": "black",
                  rounded: ""
                }, null, 8, ["loading"])
              ]),
              _: 1
            }, 8, ["onSubmit"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}